import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		token: localStorage.token ? localStorage.token : '',
		userInfo: sessionStorage.userInfo ? JSON.parse(sessionStorage.userInfo) : {},
		routerStore: sessionStorage.routerStore ? JSON.parse(sessionStorage.routerStore) : {menu: {active:'index'}},
		refreshOptions: {
			pullDownRefresh: {
				threshold: 90,
				stop: 40,
				txt: '刷新成功'
			},
			pullUpLoad: {
				threshold: 0,
				txt: {
					more: '加载更多',
					noMore: '没有更多数据'
				}
			}
		},
		popupTime:2000,
		sendTime:60,
		crtUploadFile:sessionStorage.crtUploadFile ? JSON.parse(sessionStorage.crtUploadFile) : '',
		bannerurl:"",
		needLoad:sessionStorage.needLoad?sessionStorage.needLoad:false,
  },
  mutations: {
	setShareUrl(state,shareUrl){
		let userInfo=state.userInfo;
		userInfo["shareUrl"]=shareUrl;
		sessionStorage.setItem('userInfo',JSON.stringify(state.userInfo))
	},
  	logout(state){
		state.token = ''
		state.userInfo = {}
		state.routerStore = {menu: {active:'index'}}
		sessionStorage.clear()
    	localStorage.removeItem('token')
  	},
  	storeUserInfo(state,data){
		state.token =data.token
		localStorage.setItem('token',state.token)
		state.userInfo = data.userinfo
    	sessionStorage.setItem('userInfo',JSON.stringify(state.userInfo))
  	},
	storeParams(state,params){
    	state.routerStore[params.name] = Object.assign({},params)
    	sessionStorage.setItem('routerStore',JSON.stringify(state.routerStore))
  	},
  	setParam(state,params){
	    if(state.routerStore[params.name]){
	      	state.routerStore[params.name][params.prop] = params.value
	      	sessionStorage.setItem('routerStore',JSON.stringify(state.routerStore))
	    }
  	},
  	setHeaderImgUrl(state,headerImgUrl){
		  let userInfo=state.userInfo;
		  userInfo.HeadImageUrl=headerImgUrl;
	
		  sessionStorage.setItem('needLoad',true)
		  sessionStorage.setItem('userInfo',JSON.stringify(userInfo))
	  },
	setBanner(state,url){
		state.bannerurl = url
	},
	storeOnlyUserInfo(state,data){
		state.userInfo = data.userinfo
    	sessionStorage.setItem('userInfo',JSON.stringify(state.userInfo))
  	},
  }
})
